import { Tag, Tooltip } from '@blueprintjs/core';
import { UserName } from '../../UserName';

export function CreatorTag({
  creatorID,
  customValueOverride,
}: {
  /** Resolved to a name via `UserName`. Ignored when `customValueOverride` is set. */
  creatorID?: string;
  customValueOverride?: string;
}) {
  const label = customValueOverride ?? <UserName clientID={creatorID ?? ''} />;
  return (
    <Tooltip content={<span>Created by {label}</span>}>
      <Tag round minimal>
        {label}
      </Tag>
    </Tooltip>
  );
}
